"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var estimate_message_custom_tag_parser_1 = require("@hikakaku/shared/util/html_parser/estimate_message_custom_tag_parser");
var RichText = function (_a) {
    var body = _a.body;
    return (react_1.default.createElement("div", { className: "estimateMessageCustomTag-RichText" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: estimate_message_custom_tag_parser_1.estimateMessageCustomTagParser.parse(body) } })));
};
exports.default = RichText;
